import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalHeader } from "reactstrap"

const CustomModalBody = ({
  children,
  size,
  modal,
  title,
  classBackground,
  onToggle,
  customClass,
}) => {
  return (
    <Modal centered={true} scrollable={true} size={size} isOpen={modal} className={customClass}
      toggle={onToggle}
    >
      {/* <ModalHeader className={classBackground} toggle={onToggle} tag="h5">
        {title}
      </ModalHeader> */}
      {children}
    </Modal>
  )
}

CustomModalBody.propTypes = {
  size: PropTypes.string,
  modal: PropTypes.bool,
  title: PropTypes.string,
  classBackground: PropTypes.string,
  onToggle: PropTypes.func,
}

CustomModalBody.defaultProps = {
  size: "lg",
  classBackground: "",
  children: <h6>children</h6>,
  onToggle: () => { },
}

export default CustomModalBody
